<template>
  <div class="live-course" style="height: 100%;">
    <iframe :src="url" width="100%" height="100%" style="border: none;"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      'success': true,
      'message': '',
      'liveId': this.$route.query.ll,
      'livePlanId': this.$route.query.pp,
      'url': '' //直播地址
    }
  },
  mounted: function() {
    this.getUrl()
  },
  methods: {
    getUrl() {
      var data = {
        'liveId': this.liveId,
        'livePlanId': this.livePlanId,
        'liveRoleType': 'Student'
      }
      this.$http.post(API_ROOT.system + '/liveRecord/getLiveAccessRoomUrl', data).then(response => {
        var result = response.data
        if (result.success) {
          this.success = result.success
          this.message = result.msg
          if(result.data != '') {
            this.url = result.data
            this.updateLifecycle()
            setInterval(() => {
              this.updateLifecycle()
            },30000)
          }else {
            this.$alert('你没有权限访问该页面', {
              confirmButtonText: '确定',
              callback: action => {
                window.location.href = '/'
              }
            })
          }
        }else {
          alert(result.msg)
        }
      }, response => {
        alert('网络繁忙，请稍后重试！')
      })
    },
    updateLifecycle() {
      var data = {
        'liveId': this.liveId,
        'livePlanId': this.livePlanId
      }
      this.$http.post(API_ROOT.system + '/liveTjkStudyRecord/updateLifecycle', data).then(response => {
        var result = response.data
        if (result.success) {
          this.success = result.success
          this.message = result.msg
        }else {
          alert(result.msg)
        }
      }, response => {
        alert('网络繁忙，请稍后重试！')
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// ./src/page/liveCourse.vue